import CustomElement from '~utilities/custom-element';

class Prank extends CustomElement {
	constructor() {
		super();

		this.choices = [
			'<span>Bericht 1</span><div>Hallo [naam], kun je mij helpen? Ik heb een probleempje. Mijn internet bankieren doet het niet en ik heb een rekening die vandaag echt betaald moet zijn. 🥴, kan jij deze spoedbetaling voor me doen? Dan stort ik het deze week terug! 🙌🏻 </div>',
			'Hoi [naam], ik sta in de mac drive, maar ik heb niet genoeg	geld op mn rekening en er staat nu een dikke file acher mij. Zou je alsjeblieft 6,95 over willen maken?',
			'Hoi [naam], Ik doe mee aan de 5 kilometer run, zou je mij kunnen	sponsoren? De deadline is vandaag! Dank je wel!',
			'[naam], Ik heb de laatste trein gemist en ik heb niet genoeg geld voor de taxi :( . zou je mij 50 euro kunnen lenen?',
			'Of tik je persoonlijke bericht :<br /><textarea placeholder="Vul hier je persoonlijke bericht in" js-custom-input id="custominput" class="prank-custom-input"></textarea>'
		];

		this.labelList = [];
		this.name = "";
		this.link = null;
		this.selectedId = -1;
		this.customInput = null;
		this.listener = false;
	}


	callback() {
		super.callback();

		this.choices = Array.from(this.element.querySelectorAll('[js-message]')).map(item => item.innerHTML);
		this.labelList = Array.from(this.element.querySelectorAll('[js-message]'));
		this.link = this.element.querySelector('[js-whatsapp-message]');
		this.name = this.element.querySelector('[js-input]');
		this.sendwhatsapp = this.element.querySelector('[js-sendwhatsapp]');

		this.updateRadioList();

		// attach listeners
		this.name.addEventListener('keyup', (e) => { this.updateRadioList(e); });
		this.name.addEventListener('change', () => { window.scrollTo(0, document.body.scrollHeight); });

		this.element.querySelectorAll('[type=radio]').forEach(radio => {
			radio.addEventListener('click', this.generateMessage.bind(this), false);
		});

		this.nextButton = this.element.querySelector('[js-next]');
		this.nextButton.addEventListener('click', (e) => {
			this.element.querySelector('[js-prankselection]').classList.remove('hidden');

			const container = document.getElementsByClassName('content--scroll')[0];
			container.querySelector('#messages').scrollIntoView({ behavior: 'smooth' });

		});
	}



	updateRadioList(e) {
		let i = 0;
		this.labelList.forEach(item => {
			item.innerHTML = this.choices[i++].replace("[naam]", this.cleanInput()).replace(" ,", ",");
		});

		this.generateMessage(e);
	}

	generateMessage(e) {
		if (!e) return;
		this.selectedId = (e.target.id.indexOf('radio-') !== -1) ? e.target.id.split("-")[1] : this.selectedId;

		if (this.selectedId == this.choices.length || e.target.id == 'custominput' && !this.selectedId) {

			this.customInput = document.getElementById('custominput');
			if (this.listener == false) {
				this.listener = true;
				this.customInput.addEventListener('keyup', (e) => { this.generateMessage(e) });
			}

			this.link.href = `https://api.whatsapp.com/send?text=${this.customInput.value} https://bit.ly/3DYi0mU`;
			this.link.setAttribute("target", "_blank");


			this.sendwhatsapp.style.display = "block";
			window.scrollTo(0, document.body.scrollHeight);
		} else {
			try {

				// https://bit.ly/3EfhLGc https://echt-nep.nl/fuik
				// https://bit.ly/3DYi0mU https://whatsappfraude.echt-nep.nl/fuik
				// https://bit.ly/3fK31oU https://whatsapp.echt-nep.nl/fuik
				const message = this.choices[this.selectedId].replace("[naam]", this.cleanInput()).replace(" ,", ",");
				this.link.href = `https://api.whatsapp.com/send?text=${message} https://bit.ly/3toE2hT`;
				this.link.setAttribute("target", "_blank");


				this.sendwhatsapp.style.display = "block";
				window.scrollTo(0, document.body.scrollHeight);
			} catch (e) {
				// no elements visible yet
			}
			// this.link.innerHTML = `${message} https://bit.ly/3AX6KUP`;
		}
	}

	cleanInput() {
		return this.name.value.replace(/'|"|`|<|>/gi, '');
	}
}



export default Prank;
